import { useLocation } from "react-router";
import { useEffect } from "react";
import ynToBool from "./ynToBool";


export const setGaEvent = ({
    event,
    ecommerce,
    ...scorn
}) => {
    if (!ynToBool(process.env.REACT_APP_ENABLE_G4)) return null;
    window.dataLayer = window.dataLayer || []
    const dataLayer = window.dataLayer
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
        event,
        ...(scorn || {}),
        ecommerce
    })
}

class TrackEventsTrigger {
    static instance;
    eventList = new Map();
    constructor() {
        if (TrackEventsTrigger.instance) return TrackEventsTrigger.instance;
        TrackEventsTrigger.instance = this
    }

    addEvent(label, data) {
        this.eventList?.set(label, data)
        return this.eventList;
    }

    removeEvent(label) {
        if (this.eventList?.get(label)) {
            this.eventList?.delete(label)
        }
        return true;
    }

    clearAllEvents() {
        this.eventList.clear()
        return this.eventList
    }

    getEvent(label) {
        return this.eventList?.has(label)
    }
}

const useGA = () => {
    const Location = useLocation();

    const eventGa = (label, data) => {
        const TrackEventsClass = new TrackEventsTrigger();
        const eventObject = {
            ecommerce: data,
        };
        let scorn = {};
        if (typeof label === 'string') {
            eventObject.event = label
        } else if (label.event) {
            const { event, ...props } = label.event;
            eventObject.event = label
            scorn = { ...props }
        } else {
            throw new Error('Evento não definido!')
        }

        if (TrackEventsClass.getEvent(eventObject.event)) return;
        TrackEventsClass.addEvent(eventObject.event, {
            ecommerce: data,
            ...scorn
        })
        setGaEvent({
            ...eventObject,
            ...scorn
        })
    }

    const eventGaUnlimited = (label, data) => {
        const eventObject = {
            ecommerce: data,
        };
        let scorn = {};
        if (typeof label === 'string') {
            eventObject.event = label
        } else if (label.event) {
            const { event, ...props } = label;
            eventObject.event = event
            scorn = { ...props }
        } else {
            throw new Error('Evento não definido!')
        }
        setGaEvent({
            ...eventObject,
            ...scorn
        })
    }

    useEffect(() => {
        const TrackEventsClass = new TrackEventsTrigger();
        TrackEventsClass.clearAllEvents()
    }, [Location])

    return {
        eventGa,
        eventGaUnlimited
    }

}

export default useGA
